import { Statistic } from '../../workers/sortAndFilter/statistics/statistics.worker';
import { Command, Data, Filters } from '../commands';
import { FilterStatisticsFactory } from '../factories';
import { Handler } from './ChainOfResponsibility';

export class FilterStatisticsHandler implements Handler {
    private nextHandler: Handler | null = null;
    private filterType: string;
    private keys: Filters;
    private command: Command;

    constructor({ filterType, keys }: { filterType: string; keys: Filters }) {
        this.filterType = filterType;
        this.keys = keys;
        this.command = FilterStatisticsFactory.createCommand(this.filterType);
    }

    setNext(handler: Handler): void {
        this.nextHandler = handler;
    }

    getNext(): Handler | null {
        if (this.nextHandler) {
            return this.nextHandler;
        }
        return null;
    }

    getCommand(): Command {
        return this.command;
    }

    handleRequest(data: Data, statistics: Statistic[]): Data {
        const statisticsData = this.command.execute(data, this.keys);
        const stats = [...statistics, statisticsData].flat() as Statistic[];

        if (this.nextHandler) {
            return this.nextHandler.handleRequest(data, stats);
        }

        return stats;
    }
}
